import { Injectable, OnDestroy } from '@angular/core';
import { CartSizeGQL } from '../graphql/gql';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CartService implements OnDestroy {

  private static readonly CART_SIZE_POLL_INTERVALL = 5 * 60 * 1000 // 5 minutes

  private cartSizeQuery = this.cartSizeGQL.watch({}, { pollInterval: CartService.CART_SIZE_POLL_INTERVALL })
  
  cartSize = toSignal(
    this.cartSizeQuery.valueChanges.pipe(map(result => result.data.cart.size)),
    { initialValue: 0 }
  )

  private visibilityChangeListener = () => {
    if (document.visibilityState === 'visible') {
      this.cartSizeQuery.refetch();
    }
  }

  constructor(private cartSizeGQL: CartSizeGQL) {
    document.addEventListener('visibilitychange', this.visibilityChangeListener)
  }

  ngOnDestroy() {
    document.removeEventListener('visibilitychange', this.visibilityChangeListener)
  }
}
